import {Component, forwardRef, Injector} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FontStyleSingleSelectEditControlComponent),
    multi: true
};

@Component({
    selector: "wbo-font-style-single-select-edit-control",
    templateUrl: "../../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        CUSTOM_VALUE_ACCESSOR
    ]
})
export class FontStyleSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<any> {

    static readonly PLAIN = 0;
    static readonly BOLD = 1;
    static readonly ITALIC = 2;
    static readonly ITALIC_BOLD = 3;

    constructor(injector: Injector) {
        super(undefined, injector);
        this.buildData();
    }

    override buildData(): void {
        this.data = [{label: "Plain", value: FontStyleSingleSelectEditControlComponent.PLAIN},
            {label: "Bold", value: FontStyleSingleSelectEditControlComponent.BOLD},
            {label: "Italic", value: FontStyleSingleSelectEditControlComponent.ITALIC},
            {label: "Italic Bold", value: FontStyleSingleSelectEditControlComponent.ITALIC_BOLD}];
    }
}
